const GiftItem = ({
  label,
  imgSrc,
  offerDesc,
  offerValue,
  classes,
  textClasses,
}: {
  label?: string;
  imgSrc?: string;
  offerDesc?: any;
  offerValue?: any;
  classes?: string;
  textClasses?: string;
}) => {
  return (
    <div className={`font-jost flex flex-col items-start gap-2 ${classes ? classes : ""}`}>
      {label && (
        <div className={"self-stretch text-[#696971] text-xs font-medium leading-4 lg:text-base lg:leading-[22px]"}>
          {label}
        </div>
      )}
      <div className={"flex items-center gap-1.5 lg:gap-3"}>
        <img className={"size-8 lg:size-12 shrink-0"} src={imgSrc} alt="cash" width={32} height={32} />
        <div
          className={`text-dark-1 text-xs font-medium leading-4 lg:text-xl lg:font-medium lg:leading-[26px] ${textClasses ? textClasses : ""}`}>
          <span className={"text-primary text-sm font-extrabold lg:text-[22px]"}>{offerValue}</span> {offerDesc}
        </div>
      </div>
    </div>
  );
};

export default GiftItem;
